import { render } from "./RenewalSectionApplicant.vue?vue&type=template&id=36e71f4c"
import script from "./RenewalSectionApplicant.vue?vue&type=script&lang=js"
export * from "./RenewalSectionApplicant.vue?vue&type=script&lang=js"

import "./RenewalSectionApplicant.vue?vue&type=style&index=0&id=36e71f4c&lang=postcss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__